export var API_URL = "https://api.k4mobility.com/iam"
export var REDIRECT_URL = "https://iam.k4mobility.com/"
export var SC_REDIRECT_URL = "https://sport.k4mobility.com/"
